const styles = {
  button: {
    height: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    fontWeight: 300,
    mb: 1,
    '&.MuiButton-outlined': {
      backgroundColor: (theme) => `${theme.palette.primary.contrastText}!important`,
      borderColor: (theme) => `${theme.palette.background.border}!important`,
    },
    '&.MuiButton-outlined:hover': {
      borderColor: (theme) => `${theme.palette.background.border}!important`,
      backgroundColor: (theme) => `${theme.palette.primary.light}!important`,
    },
  },
}

export default styles
